import { useSelector } from 'react-redux';

import { Skeleton } from '../../../../../components/common';
import {
    makeSelectPageSubscriberIdTranslation,
    makeSelectTranslationCommon,
} from '../../../../../modules/internationalization/intSelectors';
import { useSubscriberIdContext } from '../../../context';
import SubscriberIdStatus from '../../SubscriberIdStatus';
import { personalDataTranslationSelector } from '../selectors';
import { useGetPersonalDataStatusQuery } from '../store';
import { SubscriberIdPersonalDataStatusSkeleton } from './SubscriberIdPersonalDataSkeleton';

const SubscriberIdPersonalDataStatus = () => {

    const { subscriberId } = useSubscriberIdContext();

    const { status: tStatus } = useSelector(makeSelectTranslationCommon());
    const { status: translationStatus } = useSelector(makeSelectPageSubscriberIdTranslation());
    const tabTranslation = useSelector(personalDataTranslationSelector());

    const { data, isFetching, error } = useGetPersonalDataStatusQuery(subscriberId);

    if (isFetching) return <Skeleton isLoading render={SubscriberIdPersonalDataStatusSkeleton}/>;
    if (error || !data) return null;

    const statusPersonalDataHintMessage: string =
        data.description
        || (data.hintCode && (tStatus.codes[data.hintCode] || tStatus.defaultMessage))
        || '';

    return (
        <SubscriberIdStatus
            {...data}
            className="personal-data__status"
            title={tabTranslation.status.title}
            tooltip={statusPersonalDataHintMessage}
            translation={translationStatus}
        />
    );
};

export default SubscriberIdPersonalDataStatus;
